import React from 'react';
import { graphql } from 'gatsby';

import BlogPageContent from '../components/Blog/BlogPageContent';

const BlogDataParser = ({ location, data }) => {
  const posts = data.posts.edges.map(({ node }) => node);

  return <BlogPageContent posts={posts} location={location} />;
};

export default BlogDataParser;

export const PageQuery = graphql`
  query BlogPostsQueryByTopic($tags_pattern: String!) {
    posts: allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___date] }
      filter: {
        frontmatter: {
          templateKey: { eq: "blog-post" }
          published: { ne: false }
          tags: { regex: $tags_pattern }
        }
      }
    ) {
      edges {
        node {
          ...postDataCard
        }
      }
    }
  }
`;
